"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ReceiptIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M3.909,22.032a.85.85,0,0,1-.85-.85V2.819a.85.85,0,0,1,.85-.85H20.091a.85.85,0,0,1,.85.85V21.182a.851.851,0,0,1-1.26.745L16.42,20.133l-3.975,1.821a.853.853,0,0,1-.721,0L7.917,20.128,4.29,21.943A.869.869,0,0,1,3.909,22.032Zm4-3.7a.855.855,0,0,1,.367.083L12.1,20.243l4-1.834a.854.854,0,0,1,.763.028l2.377,1.307V3.668H4.759V19.807l2.77-1.386A.858.858,0,0,1,7.909,18.332Z" }),
        react_1.default.createElement("rect", { x: "10.476", y: "7.8", width: "6.939", height: "1.699" }),
        react_1.default.createElement("rect", { x: "10.476", y: "12.863", width: "6.939", height: "1.699" }),
        react_1.default.createElement("circle", { cx: "7.587", cy: "8.65", r: "1.094" }),
        react_1.default.createElement("circle", { cx: "7.587", cy: "13.713", r: "1.094" })));
}
exports.default = ReceiptIcon;
